import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import faqsBanner from "../assets/images/4.png";
import faqs from "../assets/data/faqs.json";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";

const FaqPage = () => {
  return (
    <>
      <Helmet>
        <title>FAQ | WeRentt</title>
        <meta
          name="description"
          content="Get answers to the most frequently asked questions about WeRentt, our services, and how we can help you with property management and rentals."
        />
        <link rel="canonical" href="https://www.werentt.com/faq" />
        {/* <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "What is Werentt?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Werentt is a house rental platform that offers fully furnished and semi-furnished flats for both short and long stays, with no brokerage or commission.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is my 1st month's rent covered in the security deposit?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "No, your first month's rent needs to be paid in addition to the security deposit to SoWeRent Technology LLP and You will have to pay the first month's rent on or before you move in to the property",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is there any brokerage fee?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "No, Werentt is completely brokerage and commission free. You only pay the rent and any applicable service",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Where are Werentt flats located?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Our flats are located PAN BANGALORE, close to Central Business District (CBD), Communities and locations with essential services.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Who can rent a Werentt flat?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Anyone can rent a Werentt flat, including families, couples, and executives.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is there a minimum stay duration?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, the minimum stay duration is one month. Longer stays come with better pricing options.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What payment methods are accepted?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "We accept various payment methods including UPI, debit cards, bank transfers, and popular online wallets.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are there any hidden charges?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "No, there are no hidden charges. All costs are transparent and listed during the booking process.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Do I need to pay a security deposit?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, a refundable security deposit is required. The amount varies depending on the property type but does not exceed two months rent.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are the flats furnished?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, we offer both fully furnished and semi-furnished flats based on your needs.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are kitchen appliances included?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, fully furnished flats come with kitchen appliances such as a refrigerator, gas stove, and basic utensils. We offer more (microwave Oven, toaster etc.) for additional charges.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I extend my stay?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, you can extend your stay at any time using our portal, mail, app or calling one of our sales executives.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I stay for just a few months?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Absolutely! We support monthly, short-term, and long-term stays.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I switch flats mid-stay?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, if there are available flats, we will assist you in relocating to another Werentt property.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What's the notice period for moving out?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "The usual notice period is 30 days, but it depends on your agreement. Short term rentals have lower notice period.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are flats bachelor-friendly?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, we have several flats designed specifically for bachelors and working professionals.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are couples allowed?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, we offer couple-friendly accommodations without any restrictions.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can students rent with Werentt?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, students can rent our flats with valid ID and documents.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are the properties safe?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, all our flats are in secure locations with CCTV camera with caretaker.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Do flats have CCTV surveillance?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, most of our properties have CCTV surveillance at entrance and common areas. Please check the specific listing for details.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is there support in case of emergencies?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, our support team is available for any emergency issues. Numbers would be displayed on each building.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I schedule a visit before booking?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, you can schedule virtual or in-person visits upon request.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "When will I receive the flat keys?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Keys are handed over on the move-in date after the final payment is cleared so we recommend clearing all payment 24 hours before check-in.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What documents do I need to move in?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "You will need to provide ID proof (Aadhar), address proof and employment proof (if required) while passport copy, visa and employment proof, university admission is mandatory for foreign nationals.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Who do I contact for help?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Our customer support team is always available via App, email, phone or chat to assist you.",
                    },
                  },
                ],
              },
            ],
          })}
        </script> */}
      </Helmet>
      <section className="about-us-page">
        <Container fluid className="px-0">
          <div className="about-banner__row">
            <div className="about-banner__col">
              <div className="about-banner">
                <img src={faqsBanner} alt="faqs" />
              </div>
            </div>
            <div className="about-banner__col">
              <div className="section-heading">
                <span>FAQs</span>
                <h2>Have Any Questions ?</h2>
                <div className="about-us-content">
                  <p>
                    SoWeRent Technology LLP provides this FAQ section to offer
                    clear and concise answers to common inquiries regarding our
                    property management services. Whether you are a property
                    owner looking to lease your property or a tenant in search
                    of your ideal home.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="faq-page-section">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <Accordion defaultActiveKey="0">
                {faqs.faq.map((faq, index) => {
                  return (
                    <Accordion.Item
                      key={index}
                      eventKey={`${index}`}
                      className="faq-card"
                    >
                      <Accordion.Header>
                        {faq.question} <FontAwesomeIcon icon={faChevronDown} />
                      </Accordion.Header>
                      <Accordion.Body>
                        {Array.isArray(faq.answer) ? (
                          faq.answer.map((item, index) => (
                            <p key={index}>{item}</p>
                          ))
                        ) : (
                          <div className="faq-info">{faq.answer}</div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FaqPage;
